module.exports = __webpack_public_path__ + "static/img/74 (1).974cc28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/74 (1).jpg
// module id = WXCY
// module chunks = 0